var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInvitedEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 303,
    viewBox: "0 0 382 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 300V123H357V300H35.0001Z",
    fill: "#FBC457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 300V123M35.0001 300H357M35.0001 300L140.422 204.063M35.0001 123H357M35.0001 123L140.422 204.063M357 123V300M357 123L250.35 204.063M357 300L250.35 204.063M250.35 204.063L195.067 246.082L140.422 204.063",
    stroke: "white",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3179_18078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.16 169.463L196.043 170.916L196.884 169.438L196.886 169.434C197.021 169.198 198.161 167.195 200.929 165.485C203.698 163.776 208.184 162.306 215.108 163.316C222.561 164.415 227.294 169.776 228.611 176.912C229.933 184.078 227.787 193.037 221.32 201.033L221.319 201.034C208.426 217.025 198.098 222.004 195.983 222.914C193.851 221.982 183.504 216.96 170.636 201.033L170.636 201.033C164.17 193.037 162.033 184.079 163.368 176.913C164.698 169.778 169.449 164.416 176.922 163.316C183.844 162.306 188.33 163.784 191.1 165.499C193.786 167.161 194.941 169.096 195.142 169.432C195.149 169.445 195.155 169.455 195.16 169.463Z",
    fill: "white",
    stroke: "#FFC629",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.018 205.721C191.69 205.721 183.92 204.478 180.443 200.676C178.149 198.19 176.262 194.351 184.771 196.472C184.771 196.472 184.845 194.717 185.03 194.607C184.845 189.014 184.475 182.946 183.477 177.17C183.44 176.841 183.625 176.658 184.401 176.585C192.097 175.744 199.866 175.744 207.598 176.585C208.338 176.658 208.56 176.841 208.523 177.17C207.524 182.946 207.154 189.014 206.969 194.607C207.154 194.754 207.228 196.472 207.228 196.472C215.738 194.351 213.851 198.19 211.594 200.676C208.116 204.514 200.347 205.721 196.018 205.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.027 194.609C192.241 196.327 199.751 196.327 207.003 194.609C207.003 194.609 207.262 194.609 207.262 195.267V198.411C207.262 198.411 204.191 200.238 196.015 200.238C187.838 200.238 184.768 198.374 184.768 198.374V195.157C184.768 195.157 184.768 194.645 185.027 194.609Z",
    fill: "#FFC629"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.364 102.616L114.748 110.327L127.33 113.325L119.619 123.709L116.621 136.291L106.237 128.58L93.6552 125.582L101.366 115.198L104.364 102.616Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.19 56.6795L301.851 72.7974L313.13 84.4297L297.013 86.0902L285.38 97.3699L283.72 81.252L272.44 69.6196L288.558 67.9591L300.19 56.6795Z",
    fill: "#2B2B2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.574 266.844L241.913 250.726L230.634 239.094L246.751 237.433L258.384 226.154L260.044 242.272L271.324 253.904L255.206 255.565L243.574 266.844Z",
    fill: "#2B2B2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.892 80.4728L260.95 84.9708L268.289 86.7197L263.791 92.7771L262.042 100.116L255.985 95.6183L248.645 93.8694L253.144 87.8121L254.892 80.4728Z",
    fill: "#2B2B2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.872 243.051L282.814 238.553L275.475 236.804L279.973 230.747L281.722 223.408L287.779 227.906L295.119 229.654L290.621 235.712L288.872 243.051Z",
    fill: "#2B2B2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 80L127.673 86.3274L134 90.5L127.673 94.6726L123.5 101L119.327 94.6726L113 90.5L119.327 86.3274L123.5 80Z",
    fill: "#2B2B2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0955 127.321L50.44 134.858L53.725 141.651L46.188 141.995L39.3959 145.28L39.0514 137.743L35.7664 130.951L43.3033 130.606L50.0955 127.321Z",
    fill: "#2B2B2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0001 55L96.7819 59.2182L101 62L96.7819 64.7818L94.0001 69L91.2184 64.7818L87.0001 62L91.2184 59.2182L94.0001 55Z",
    fill: "#2B2B2B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6507 104.228L12.8722 109.073L14.984 113.44L10.1388 113.661L5.77241 115.773L5.55094 110.928L3.43916 106.561L8.28434 106.34L12.6507 104.228Z",
    fill: "#2B2B2B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316 148L318.782 151.917L323 154.5L318.782 157.083L316 161L313.218 157.083L309 154.5L313.218 151.917L316 148Z",
    fill: "#2B2B2B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375 105L377.782 108.917L382 111.5L377.782 114.083L375 118L372.218 114.083L368 111.5L372.218 108.917L375 105Z",
    fill: "#2B2B2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M362 91L363.59 93.4104L366 95L363.59 96.5896L362 99L360.411 96.5896L358 95L360.411 93.4104L362 91Z",
    fill: "#2B2B2B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168 252L169.59 254.41L172 256L169.59 257.59L168 260L166.411 257.59L164 256L166.411 254.41L168 252Z",
    fill: "#2B2B2B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 105L39.5897 107.109L42.0001 108.5L39.5897 109.891L38.0001 112L36.4105 109.891L34.0001 108.5L36.4105 107.109L38.0001 105Z",
    fill: "#2B2B2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.969 3.43915L271.19 8.28434L273.302 12.6507L268.457 12.8722L264.09 14.984L263.869 10.1388L261.757 5.7724L266.602 5.55094L270.969 3.43915Z",
    fill: "#2B2B2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3179_18078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 62,
    fill: "white",
    transform: "translate(162 162)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInvitedEnvelope);
export default __webpack_public_path__ + "static/media/not-invited-envelope.3f3e1bd5810d2e7770b2be0052246a5f.svg";
export { ForwardRef as ReactComponent };